module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "cascader",
    staticClass: "cascader-container",
    class: [_vm.size ? _vm.size : '']
  }, [_c('div', {
    class: {
      'cascader': true,
      'is-disabled': _vm.disabled,
      'focus': _vm.isFocus
    },
    on: {
      "mouseenter": function($event) {
        _vm.inputHover = _vm.disabled ? false : true
      },
      "mouseleave": function($event) {
        _vm.inputHover = false
      },
      "click": function($event) {
        $event.stopPropagation();
        _vm.operateMenu($event)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputValue),
      expression: "inputValue"
    }],
    ref: "input",
    attrs: {
      "type": "text",
      "readonly": !_vm.filterable,
      "placeholder": _vm.currentLabel && _vm.currentLabel.length > 0 ? undefined : _vm.placeholder
    },
    domProps: {
      "value": (_vm.inputValue)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.inputValue = $event.target.value
      }, _vm.inputChange],
      "blur": _vm.blur
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showLabel),
      expression: "showLabel"
    }],
    staticClass: "result-label"
  }, [_vm._v("\n            " + _vm._s(_vm.currentLabel) + "\n        ")]), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.clearable && _vm.inputHover && _vm.currentLabel),
      expression: "clearable && inputHover && currentLabel"
    }],
    staticClass: "close-btn",
    class: [_vm.isBasic ? 'el-icon-circle-close' : 'tofu-icon icon-close-circle'],
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.clear($event)
      }
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!(_vm.clearable && _vm.inputHover && _vm.currentLabel)),
      expression: "!(clearable && inputHover && currentLabel)"
    }],
    staticClass: "icon-arrow",
    class: [{
        'is-reverse': _vm.showMenu
      },
      _vm.isBasic ? 'el-icon-caret-top' : 'tofu-icon icon-arrow-down'
    ]
  })]), _vm._v(" "), _c('cascader-menu', {
    attrs: {
      "options": _vm.options,
      "hasMenu": _vm.hasMenu,
      "showMenu": _vm.showMenu,
      "props": _vm.props,
      "value": _vm.currentValue,
      "changeOnSelect": _vm.changeOnSelect,
      "expandTrigger": _vm.expandTrigger
    },
    on: {
      "pick": _vm.pick,
      "active-item-change": _vm.handleActiveItemChange
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "on-after-leave": "handleFMenuLeave"
    }
  }, [(_vm.filterable) ? _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFMenu),
      expression: "showFMenu"
    }],
    staticClass: "filterable-menu",
    style: ({
      height: _vm.searchOptions.length > 0 ? '200px' : '52px'
    })
  }, [(_vm.searchOptions.length <= 0) ? _c('li', {
    staticClass: "is-disabled"
  }, [_vm._v("无匹配数据")]) : _vm._l((_vm.searchOptions), function(option) {
    return _c('li', {
      class: {
        'is-disabled': option.disabled
      },
      on: {
        "click": function($event) {
          _vm.pick(option.value)
        }
      }
    }, [_vm._v("\n                " + _vm._s(option.label) + "\n            ")])
  })], 2) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6304c713!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cascader/src/cascader.vue
// module id = 653
// module chunks = 0